import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { SinglePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/PaymentMethodDetail/SinglePaymentMethodDetailEntity';
import { NextActionPayment } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/NextActions/components/Payment/NextActionPayment';

interface NextActionFactoryProps {
  action: Action;
  paymentMethodDetailEntity: SinglePaymentMethodDetailEntity;
}

// TODO: Separate actions into components
export const NextActionFactory = ({ action }: NextActionFactoryProps) => {
  if (action === Action.PAY) {
    return <NextActionPayment />;
  }

  return null;
};
